import { EveRoutes } from '@ver-uds/e-verify';
import { useAuthState } from '@vis-auth/react';
import { EverifyUserRole } from '@vis-auth/vis-user-client';
import React, { useEffect } from 'react';
import ReactGA from 'react-ga4';
import { Redirect, useLocation } from 'react-router-dom';

const ProfilePage = (): JSX.Element => {
  const { user } = useAuthState();
  const location = useLocation();
  useEffect(() => {
    ReactGA.send({
      hitType: 'pageview',
      pageTitle: 'E-Verify - Profile Page',
    });
  }, []);
  if (user?.roles.includes(EverifyUserRole.CORPORATEADMIN)) {
    return <Redirect to={{ pathname: EveRoutes.CORPORATE_PROFILE_VIEW, state: location.state }} />;
  }

  return <Redirect to={{ pathname: EveRoutes.COMPANY_PROFILE_VIEW, state: location.state }} />;
};

export default ProfilePage;
